import { Game } from "entities/game/types";
import {
  GamesOrderType,
  ModuleGame,
  ModuleGameStatus,
  ModuleType,
  SelectedGame,
} from "entities/modules/types";
import { PageModuleData } from "entities/pages/types";
import { Studio } from "entities/studios/types";
import shuffle from "lodash/shuffle";
import { SelectOption } from "shared/components/Form/Select";
import { StudioOption } from "../components/Tabs/Content/Studios/components/StudiosAutocomplete";
import {
  gamesLayoutOptions,
  gamesLayoutOptionsWithStudioFilter,
  studiosLayoutOptions,
} from "./constants";

type GetLayoutOptionsByTypeParams = {
  moduleType: ModuleType;
  studioFilterEnabled?: boolean;
};

export const getLayoutOptionsByType = (
  params: GetLayoutOptionsByTypeParams,
): SelectOption[] => {
  switch (params.moduleType) {
    case ModuleType.Studios:
      return studiosLayoutOptions;
    case ModuleType.Games:
      if (params.studioFilterEnabled) {
        return gamesLayoutOptionsWithStudioFilter;
      }
      return gamesLayoutOptions;
    default:
      return [];
  }
};

export const formatStudios = (
  moduleData: PageModuleData,
  studios?: Studio[],
): StudioOption[] => {
  return moduleData.selectedStudiosIds?.map((studioId) => {
    const studioName =
      studios?.find(({ id }) => String(id) === studioId)?.name || "";

    return {
      id: studioId,
      name: studioName,
    };
  });
};

export const formatSelectedGames = (
  data: Game[],
  gamesOrderType: GamesOrderType,
  studios?: Studio[],
  selectedGames?: ModuleGame[],
): SelectedGame[] => {
  if (!data.length) {
    return [];
  }

  const shuffledArray =
    gamesOrderType === GamesOrderType.Random ? shuffle(data) : data;

  return shuffledArray.map((game, index) => {
    const studioId: number | null = game.productSupplierId;
    const studio = studios?.find((s) => s.id === studioId);
    const selectedGameStatus = selectedGames?.find(
      ({ id }) => id === String(game.id),
    )?.status;

    return {
      id: String(game.id),
      name: game.displayName,
      order: index + 1,
      studioId,
      studioName: studio?.name,
      status: selectedGameStatus || ModuleGameStatus.Active,
      tagTypes: game.tagTypes,
      tags: game.tags,
    };
  });
};
